import { useTranslation } from "react-i18next";
import LegalDocumentPage, {
  LegalSection,
} from "../components/legal/LegalDocumentPage";
import { WEB_URL } from "../constants";

const PrivacyPolicy = () => {
  const { t } = useTranslation();

  const sections: LegalSection[] = [
    {
      title: t("privacyPolicySectionCollectionTitle"),
      paragraphs: [t("privacyPolicySectionCollectionBody")],
      bullets: [
        t("privacyPolicySectionCollectionBullet1"),
        t("privacyPolicySectionCollectionBullet2"),
        t("privacyPolicySectionCollectionBullet3"),
      ],
    },
    {
      title: t("privacyPolicySectionUsageTitle"),
      paragraphs: [t("privacyPolicySectionUsageBody")],
      bullets: [
        t("privacyPolicySectionUsageBullet1"),
        t("privacyPolicySectionUsageBullet2"),
        t("privacyPolicySectionUsageBullet3"),
      ],
    },
    {
      title: t("privacyPolicySectionSharingTitle"),
      paragraphs: [t("privacyPolicySectionSharingBody")],
    },
    {
      title: t("privacyPolicySectionSecurityTitle"),
      paragraphs: [t("privacyPolicySectionSecurityBody")],
    },
    {
      title: t("privacyPolicySectionChoicesTitle"),
      paragraphs: [t("privacyPolicySectionChoicesBody")],
    },
    {
      title: t("privacyPolicySectionUpdatesTitle"),
      paragraphs: [t("privacyPolicySectionUpdatesBody")],
    },
  ];

  return (
    <LegalDocumentPage
      title={t("privacyPolicyTitle")}
      lastUpdatedLabel={t("legalLastUpdated")}
      lastUpdatedValue={t("privacyPolicyLastUpdatedValue")}
      intro={[
        t("privacyPolicyIntro1"),
        t("privacyPolicyIntro2"),
      ]}
      sections={sections}
      contactTitle={t("legalContactTitle")}
      contactDescription={t("privacyPolicyContactBody")}
      websiteLabel={t("legalWebsiteLabel")}
      websiteUrl={WEB_URL}
      phoneLabel={t("legalPhoneLabel")}
      phoneValue="626-968-2688 / 626-968-7100"
    />
  );
};

export default PrivacyPolicy;
